import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import proposalKeys from '@/api/queries/proposal/keyFactor';
import { graphql } from '@/gql';
import {
  CreateProposalLineItemInput,
  CreateProposalLineItemMutation,
} from '@/gql/graphql';

const CREATE_PROPOSAL_LINE_ITEM_MUTATION = graphql(`
  mutation CreateProposalLineItem($input: CreateProposalLineItemInput!) {
    createProposalLineItem(input: $input) {
      id
    }
  }
`);

const useCreateProposalLineItem = (args?: {
  proposalId?: string;
  options?: UseMutationOptions<
    CreateProposalLineItemMutation,
    unknown,
    CreateProposalLineItemInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};

  return useMutation({
    mutationFn: (input: CreateProposalLineItemInput) => {
      return gqlClient.request(CREATE_PROPOSAL_LINE_ITEM_MUTATION, { input });
    },
    onSuccess: (data, variables, context) => {
      if (args?.proposalId) {
        void queryClient.invalidateQueries({
          queryKey: proposalKeys.proposal(args.proposalId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useCreateProposalLineItem;
